import { render, staticRenderFns } from "./CustodyExpenseAdd.vue?vue&type=template&id=5ccbe513&"
import script from "./CustodyExpenseAdd.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports